<template>
  <b-nav-item
    :to="{ name: 'chat-bot' }"
    class="mr-25"
  >
    <feather-icon
      icon="MessageSquareIcon"
      size="21"
      class="text-body"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem } from 'bootstrap-vue'

export default {
  components: {
    BNavItem,
  },
}
</script>
